module.exports = __webpack_public_path__ + "static/media/img1.bd2117f4.jpg";